import { UserActionTypes } from "@/store/modules/user/action-types";

/** 清除 token、角色、菜单等登录态（localStorage + Vuex + 动态路由） */
export function resetAuthState() {
  const { store } = require("@/store");
  store.dispatch(UserActionTypes.ACTION_RESET_TOKEN, undefined);
}
